<template>
  <div>
    <div class="container">
      <div style="margin-bottom: 20px; margin-right: 80px; " size="medium">
        <el-radio-group v-model="radioCycle">
          <el-radio-button label="daily"></el-radio-button>
          <el-radio-button label="weekly"></el-radio-button>
          <el-radio-button label="monthly"></el-radio-button>
        </el-radio-group>

        <el-button type="primary" @click="exportCsv"   style="margin-left: 80px;" >下载 CSV</el-button>

      </div>
    </div>

    <el-table :data="tableData" stripe style="width: 100%" height="950"
      :default-sort="{ prop: 'date', order: 'descending' }">
      <el-table-column prop="date" label="日期" width="210" sortable>
      </el-table-column>
      <el-table-column prop="activate" label="新增激活" width="50">
      </el-table-column>
      <el-table-column prop="activate_total" label="激活设备数">
      </el-table-column>
      <el-table-column prop="activate_new" label="激活新设备" width="65">
      </el-table-column>
      <el-table-column prop="activate_old" label="激活老设备">
      </el-table-column>

      <el-table-column prop="card_new" label="新增绑卡">
      </el-table-column>


      <el-table-column prop="uncard_total" label="激活未绑卡">
      </el-table-column>
      <el-table-column prop="uncard_balance" label="未绑卡变化">
        <template slot-scope="scope">
          <span :style="{ color: getBalanceColorBad(scope.row.uncard_balance) }">{{ scope.row.uncard_balance }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="card_total" label="历史绑卡">
      </el-table-column>
      <el-table-column prop="card_rate" label="历史绑卡率">
      </el-table-column>



      <el-table-column prop="untrialed" label="未试用设备" width="65">
      </el-table-column>
      <el-table-column prop="trialed" label="试用设备数" width="65">
      </el-table-column>
      <el-table-column prop="trial_rate" label="激活试用率">
      </el-table-column>
      <el-table-column prop="trial_to_subs" label="试用后付费">
      </el-table-column>
      <el-table-column prop="trial_subs_rate" label="历史试用转化率">
      </el-table-column>


      <el-table-column prop="subs_total" label="历史付费数">
      </el-table-column>
      <el-table-column prop="subs_count" label="当前付费数">
      </el-table-column>
      <el-table-column prop="subs_count_rate" label="当前付费占比">
      </el-table-column>
      <el-table-column prop="subs_activate_rate" label="历史付费激活占比">
      </el-table-column>
      <el-table-column prop="subs_trialed_rate" label="历史付费试用占比">
      </el-table-column>
      <el-table-column prop="subs_new" label="新增订阅" width="50">
      </el-table-column>
      <el-table-column prop="subs_churn" label="流失订阅" width="50">
      </el-table-column>
      <el-table-column prop="subs_recall" label="召回订阅" width="50">
      </el-table-column>
      <el-table-column prop="subs_balance" label="净增加" width="50">
        <template slot-scope="scope">
          <span :style="{ color: getBalanceColor(scope.row.subs_balance) }">{{ scope.row.subs_balance }}</span>
        </template>
      </el-table-column>

    </el-table>

  </div>
</template>
  
<script>

import { exportToCsv } from '@/utils/exportToCsv';

export default {
  data() {
    return {
      tableData: [],
      radioCycle: 'daily'
    }
  },

  watch: {

    $route(newVal, oldVal) {
      this.getData(newVal.params.bike_type, newVal.params.cycle)
    },
    radioCycle(newV, oldVal) {
      this.$router.replace(`/retention/${this.$route.params.bike_type}/${newV}`)
    }


  },
  created: function () {
    //注意回调函数的作用域!!!
  },
  mounted: function () {
    const bike_type = this.$route.params.bike_type;
    const cycle = this.$route.params.cycle;
    this.getData(bike_type, cycle)
  },

  
  methods: {
    
    exportCsv(){
      let  fileName  =   "retention_"+ this.$route.params.bike_type+  "_"+ this.$route.params.cycle
      exportToCsv(this.tableData,fileName)
    },

    async getData(bike_type, cycle) {
      // let bike_type = bike_type;
      // let cycle = "xbike";
      this.tableData = []

      let res = await this.$http.get("/da/retention/" + bike_type + "/" + cycle)
      this.tableData = res.data
      console.log(res.data)
    },
    getBalanceColorBad(value) {
      if (value < 0) {
        return 'green'; // 数量小于10，设置颜色为绿色
      } else if (value >= 0 && value < 1) {
        return 'orange'; // 数量在10到20之间，设置颜色为橙色
      } else {
        return 'red'; // 数量大于等于20，设置颜色为红色
      }
    },
    getBalanceColor(value) {
      if (value > 0) {
        return 'green'; // 数量小于10，设置颜色为绿色
      } else if (value >= 0 && value < 1) {
        return 'orange'; // 数量在10到20之间，设置颜色为橙色
      } else {
        return 'red'; // 数量大于等于20，设置颜色为红色
      }
    }
  },

  // 检查路由,是的筛选按钮匹配路由数值
  beforeRouteUpdate(to, from, next) {
    // 检查路由参数是否发生变化
    if (to.params.bike_type !== from.params.bike_type || to.params.cycle !== from.params.cycle) {
      // 更新 el-radio-group 的选择项
      this.radioCycle = to.params.cycle;
    }
    next();
  },



}
</script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.container {
  display: flex;
  justify-content: flex-end;
}
</style>
  